module.exports = __webpack_public_path__ + "img/38-70b536.png";